module.exports = {"TXTWCL_24_hour_lockout":{"id":"TXTWCL_24_hour_lockout","defaultMessage":"Lock-out van 24 uur"}}